module.exports = __webpack_public_path__ + "img/left-v2.67619a04.svg";